import info_circle from './img/bx-info-circle.svg';
import "./StepItem.scss"

const StepItem = ({ 
    title, 
    description = false
 }) => {

    return (
        <div className="step-item-component" key={title}>
            <p className="step-item-component__step-info">
                <img
                    src={info_circle}
                    className="step-item-component__img"
                    alt='icon'
                />
                {title}
            </p>
            {description
                &&
                <p className="step-item-component__step-description">
                    {description}
                </p>}
        </div>
    )
}

export { StepItem }